<div class="updox-folder-list">
  <button type="button" class="btn btn-secondary btn-block mb" (click)="newMessage.emit()">
    <i class="fa fa-pencil-square-o mr-sm fs18"></i> New Message
  </button>

  <p class="text-muted fs12 p-sm m0 updox-text-ellipsis" *ngIf="userAddress" title="{{ userAddress }}">
    <i class="fa fa-user-circle-o mr-xs"></i> {{ userAddress }}
  </p>
  <ul class="list-unstyled m0">
    <li>
      <a class="updox-folder-item"
         [class.active]="activeView === 'inbox'"
         (click)="select('inbox')">
        <i class="fa fa-inbox mr-sm"></i>
        <span>Inbox</span>
        <span class="label label-success pull-right" *ngIf="counts.inbox > 0">{{ counts.inbox }}</span>
      </a>
    </li>
    <li>
      <a class="updox-folder-item"
         [class.active]="activeView === 'draft'"
         (click)="select('draft')">
        <i class="fa fa-file-text-o mr-sm"></i>
        <span>Drafts</span>
        <span class="label label-info pull-right" *ngIf="counts.draft > 0">{{ counts.draft }}</span>
      </a>
    </li>
    <li>
      <a class="updox-folder-item"
         [class.active]="activeView === 'sent'"
         (click)="select('sent')">
        <i class="fa fa-send-o mr-sm"></i>
        <span>Sent</span>
      </a>
    </li>
    <li>
      <a class="updox-folder-item"
         [class.active]="activeView === 'deleted'"
         (click)="select('deleted')">
        <i class="fa fa-trash-o mr-sm"></i>
        <span>Trash</span>
        <span class="label label-warning pull-right" *ngIf="counts.deleted > 0">{{ counts.deleted }}</span>
      </a>
    </li>
  </ul>

  <hr class="m-sm">

  <ul class="list-unstyled m0">
    <li>
      <a class="updox-folder-item"
         [class.active]="activeView === 'contacts'"
         (click)="select('contacts')">
        <i class="fa fa-address-book-o mr-sm"></i>
        <span>Contacts</span>
      </a>
    </li>
  </ul>
</div>
